import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; 
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);